const Form091TC = {
    stepName: {
        importantNotes: "重要事項",
        applicationInformation: "申請人資料",
        declaration: "確認頁面",
    },
    noteList: {
        note1: "申請資助為資優學生提供校外進階學習課程（{{schoolyear}} 學年）",
        note2: "注意事項：",
        note3: '在填寫本申請表格前，請先細閱《申請指引》（<a style="color: blue" href="https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html" target="_blank" rel="noopener noreferrer">https://www.edb.gov.hk/en/curriculum-development/curriculum-area/gifted/ge_fund/gef/asp.html</a>）。',
        note4: "每個課程應填寫一份申請表格，每間機構可遞交多於一份申請。",
        note5: "備註：",
        note6: "請於{{deadline}}，",
        note7: "將本申請表格連同課程建議書提交資優教育基金秘書處。",
        note8: "上載文件：",
        note8_1: "填妥的申請表格連同課程建議書一份",
        note8_2:
            "申請機構的相關註冊文件複本（例如：商業登記證）或根據《稅務條例》第 88 條獲豁免繳稅（如適用）",
        number1: "1.",
        number2: "2.",
        number3: "3.",
        number4: "4.",
        number5: "5.",
        number6: "6.",
        number7: "7.",
        tooltip: "例如：專上院校學系／學院的主管或機構的主席／執行董事",
        tooltip_totalMonths:
            "此項數值由 （甲） 籌備課程 與 （乙） 推行課程之和自動計算所得。",
        tooltip_totalGrantSought:
            "此項數值由乙部及丙部財政預算的申請資助總額自動計算所得。",
        iamStatement:
            "本人理解申請人和申請機構審批人需要擁有「智方便+」帳戶才能處理申請。",
        additionNotice_1: "請自行列印PDF檔以供機構主管簽署及／或協辦機構蓋印。",
    },
    label: {
        partA: "甲部：課程資料",
        titleOfProgramme: "課程名稱",
        english: "（英文）",
        chinese: "（中文）",
        themeOfProgramme: "課程主題",
        theme: "主題",
        pleaseSpecify: "請說明",
        openBracket: "（",
        closeBracket: "）",
        underline: "_____________",
        targetBeneficiary: "受惠對象",
        target: "對象",
        targetPrefer: "（建議約50位學生；例如：50位中一至中二年級的學生）",
        targetBeneficiaryNumber: "（甲）學生人數",
        targetBeneficiaryLevel: "（乙）學生級別",
        programmePeriod: "課程所需時間：",
        months: "個月",
        preparation: "（甲）籌備課程（3個月）",
        preparation1: "（甲）籌備課程",
        preparation2: "（3個月）",
        delivery: "（乙）推行課程（不超過5個月）： ",
        delivery1: "（乙）推行課程",
        delivery2: "（不超過5個月）： ",
        total: "（丙）共：",
        closeSquareBracket: "月（建議6至15個月）",
        grantSought: "申請資助金額：合共港幣＄",
        particularsOfOrganisation: "機構資料：",
        applicantOrganisation: "主辦機構",
        supportingOrganisation: "協辦機構（如有）",
        supportingOrganisations: "協辦機構",
        name: "機構名稱",
        headOfOrganisation: "機構主管",
        postTitle: "主管職銜",
        address: "機構地址",
        programmeLeader: "課程負責人資料：",
        nameAndPost: "姓名",
        post: "職銜",
        telephoneNumber: "聯絡電話",
        officeHours: "（辦公時間）",
        outsideOfficeHours: "（非辦公時間）",
        emailAddress: "電郵地址",
        emailMain: "（主要電郵）",
        emailBackup: "（備用電郵）",
        faxNumber: "傳真號碼",
        partB: "乙部：課程建議書摘要",
        provideSummary:
            "請就以下項目提供課程建議書的摘要，內容限於一頁A4紙，字型不小於12點。",
        goal: "目標和目的",
        selection:
            "甄選資優學生參加課程的機制（例如：學生在申請表上所填報的資料／筆試／會面）",
        mechanism: "機制",
        implementation1: "課程推行：",
        implementation2: "主要籌備工作（例如：人力資源安排、準備學習資源）",
        implementation3:
            "課程概述（例如：第一階段學習有關氣象學和電腦編程的基礎知識和技能；第二階段就進階課題進行深入學習；第三階段進行為期3個月在良師啟導下的獨立專題研習；第四階段在公開活動展示學生的學習成果）",
        implementation4:
            "師生會面時間和頻次（例如：9個月［每星期3小時課堂／會面］）",
        implementation5:
            "人力資源及員工聘請（例如：聘請1名全職課程助理以協助處理課程的行政工作）",
        implementation6:
            "與其他團體／機構進行協作（例如：與一個本地專業團體合作）",
        description: "概述",
        grantSoughtAndExpenditure: "申請資助金額及開支項目（港幣＄）：",
        staffCost: "薪金",
        equipment: "設備",
        services: "服務",
        generalExpenses: "一般開支",
        contingency: "應急費用",
        others: "其他（請說明）",
        totalGrantSought: "申請資助總額",
        expected: "預期學生的學習成果和成品",
        current: "已與小學和中學建立的網絡（如有）或吸引學生報名的推廣計劃",
        networkOrPlan: "網絡或計劃",
        proposed:
            "質素保證機制建議：（例如：成立質素保證小組、三個月召開一次的質素保證會議、評估學生學習成效、透過會面和問卷以收集學生回饋等）",
        proposedQualityAssuranceMechanism: "質素保證機制建議",
        partC: "乙部：課程内容",
        elaborate:
            "課程審批準則包括但不限於以下三方面：（I）課程需求、（II）課程可行性及（III）預期成果和質素保證。",
        programmeNeeds: "（I）課程需要",
        programmeFeasibility: "（II）課程可行性",
        expectedOutcome: "（III）預期課程成果和質素保證",
        rationale: "理念",
        rationale2: "（為何建議舉辦這個課程？）",
        goal2: "（參考例子：",
        goal3: "目標：進一步發揮資優學生的潛能",
        goal4: "目的：加強資優學生綜合和應用跨學科知識與技能的能力，以解決進階的科學難題；及培養學生面對逆境的正面價值觀和態度）",
        hyphen: "-",
        goal5: "加強資優學生綜合和應用跨學科知識與技能的能力，以解決進階的科學難題；及",
        goal6: "培養學生面對逆境的正面價值觀和態度）",
        targetBeneficiary2: "受惠對象（例如：50名中一至中二年級的學生）",
        prerequisite1: "修讀條件",
        prerequisite2:
            "（參考例子：學生在學校的科學科／數學科表現卓越，並須具備電腦編程的基礎知識。如果沒有修讀條件，請填「無」。）",
        prerequisite3: "（如果沒有，請填寫'無'。）",
        selection1: "甄選機制",
        selection2:
            "（例如：學生在申請表上所填報的資料／筆試／會面［請詳述］）",
        programmePeriod1: "課程所需時期",
        programmePeriod2: "{{periodExample}}",
        programmePeriodPreparation: "籌備課程所需時期",
        programmePeriodDelivery: "推行課程所需時期",
        preparationPartC: "籌備課程：",
        deliveryPartC: "推行課程：",
        fromPartC: "由",
        toPartC: "至",
        mediumOfInstruction1: "授課語言",
        mediumOfInstruction2: "課程教材：",
        mediumOfInstruction3: "（參考例子：英文）",
        mediumOfInstruction4: "教學 ／ 討論：",
        mediumOfInstruction5: "（參考例子：以英語為主，輔以廣東話）",
        keyImplementation1: "課程推行的主要資料：",
        keyImplementation2:
            "（除籌備期外，課程推行應介乎5-7個月。每個課程的總授課時數不可超過100小時。請闡述課程每階段的課堂內容、學與教活動、教學模式（網上教學 ／ 面授課堂）、課堂數目等。請詳細說明課程的特點及其可行性。如有需要，請在下表插入新行及／或將課程劃分為不同階段。如有需要，可附上證明文件以說明課程的推行計劃。）",
        eg1: "參考例子",
        implementationPeriod1: "推行時期",
        implementationPeriod2: "202X年5月至7月",
        implementationPeriod3: "推行時期",
        numContactHours: "授課時數（只需輸入數字）",
        numContactHours1: "30",
        content1: "內容 ／ 活動 ／ 模式 ／ 課堂數目",
        content2:
            "（例如：第一階段：掌握氣象學的基礎知識，及運用雲端電腦技術模擬熱帶氣旋的路徑和估算相關的風暴潮：8節［每節3小時］面授課堂［8個有關氣象學／數據分析的主題］及6小時電腦編程課堂［合共30小時，為期3個月］）",
        content2_1: "第一階段（為期3個月，共30小時）",
        content2_2:
            "面授課堂：掌握氣象學的基礎知識，及運用雲端電腦技術模擬熱帶氣旋的路徑和估算相關的風暴潮",
        content2_3:
            "包括8節（每節3小時）有關氣象學 / 數據分析的課堂及1節6小時電腦編程課堂",
        manpower1: "人力資源計劃：",
        manpower2: "（如有需要，請選擇「增加」以插入新行。）",
        post1: "職銜",
        post2: "1名課程助理",
        qualification1: "學術資格及 / 或專業資格及 / 或工作經驗",
        qualification2:
            "（例如：與科學範疇相關的學士學位或以上學歷及具備至少3年籌辦以中學生為對象的培訓課程的經驗）",
        qualification2_1: "與科學範疇相關的學士學位或以上學歷及",
        qualification2_2: "具備至少3年籌辦以中學生為對象的培訓課程的經驗",
        roles1: "角色 ／ 職責",
        roles2: "（請說明：全職 ／ 兼職 ／ 工作總月數 ／ 小時）",
        roles3: "（例如，（甲）協助進行課程的日常管理；以及（乙）協助處理與課程相關的學生事務）",
        roles3_1: "協助進行課程的日常管理及",
        roles3_2: "協助處理與課程相關的學生事務",
        engagementMode1: "參與方式",
        engagementMode2:
            "全職（以月份計算）/ </br>兼職（以小時計算）/ </br>其他（請注明）",
        engagementTime1: "參與時間（月 / 小時）",
        engagementTime2: "6個月",
        engagementMonths: "月",
        engagementHours: "小時",
        budgetPlan1: "財政預算：",
        budgetPlan2: "（請參閱《申請指引》內附件I「財政預算指引」）",
        items: "項目",
        particulars: "詳情及理據",
        breakdown: "分項",
        amount: "金額（港幣＄）",
        respectiveRoles: "主辦機構和協辦機構分別的角色（如適用）：",
        role: "角色",
        experience: "資優教育 ／ 人才培育相關經驗（如適用）：",
        experience2: "",
        currentNetworks1:
            "已與小學和中學建立的網絡（如有）或吸引學生報名的推廣計劃：",
        currentNetworks2: "（參考例子：舉辦網上簡介會向學校介紹課程）",
        expectedLearningOutcomes1: "預期學生的學習成果及成品：",
        expectedLearningOutcomes2:
            "（參考例子：課程結束後，學生能運用雲端運算技術解決高階科學問題，並在展示會中報告研究成果。）",
        expectedLearningOutcomes3: "預期學生的學習成果及成品",
        proposed2: "質素保證機制建議：",
        proposed3:
            "（建議的機制須包括質素保證小組的組成及訂定確保課程質素的措施，例如：評估的形式和次數、導師的訓練和課前準備。）",
        partD: "丙部：聲明和同意書",
        iHaveRead:
            "本人已閱讀並完全明白《申請指引》的內容。本人聲明本機構符合申請資格，申辦課程亦沒有從政府取得其他資助。",
        iCertify:
            "本人聲明所提供的資料屬實及準確無誤。本人明白如提供的資料不正確，本申請將會無效，任何獲批的款項將會被停止發放，而所有已獲取的款項亦必須退還予資優教育基金。",
        iAgree: "本人已閱讀《申請指引》附件II「有關收集個人資料的聲明」。本人同意在此申請內提供的資料，可供資優教育基金秘書處和相關政府決策局 ／ 部門處理申請及相關用途。",
        iUnderstand:
            "本人明白，所有申請資優教育基金的建議書將以競逐的方式處理。在挑選過程中，教育局擁有最終的決定權。",
        nameAndPostTitle: "姓名及職銜",
        postTitleD: "職位名稱",
        nameOfOrganisation: "機構名稱",
        attachment: "附件",
        attachmentNote: "備註",
        edbDocument: "附件（由教育局上載）",
    },

    select: {
        engagementMode: {
            fullTime: "全職（以月份計算）",
            partTime: "兼職（以小時計算）",
            others: "其他（請注明）",
        },
        targetBeneficiaryLevel: {
            primary: "（i） 高小（小四至小六）",
            secondary: "（ii） 初中（中一至中三）",
            higher: "（iii） 高中（中四至中五）",
            secondaryAndHigher: "（iv） 初中和高中（中一至中五）",
        },
    },

    formContent: {
        themeOfProgrammeOption: {
            stem: "數字教育 / STEAM 相關進階學習",
            humanities: "人文學科和社會科學研究課程",
            apprenticeship: "實習及企業體驗學習課程",
            selfInitiated: "由學生主動提出的研習",
            others: "其他",
        },
    },
    errorMsg: {
        telNo: "電話號碼必須為8位數字",
        faxNo: "傳真號碼必須為8位數字",
        differentFromPartC: "輸入數值應與「丙部 - 財政預算 申請資助總額」相同",
        differentFromPartB: "輸入數值應與「乙部 - 4.申請資助總額」相同",
        delivery: "請輸入一個有效的推行課程",
        numContactHoursTotal: "授課時數總時長不應超過100小時",
        engagementTime: "請輸入0-200之間的數字",
        targetBeneficiary: "請輸入30-60之間的數字",
    },
    pics: {
        title: "個人資料收集聲明",

        h1: "收集個人資料的目的",
        p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        p1_1_a: "處理、核實及查證就資優教育基金資助的申請；",
        p1_1_b: "就上文（a）項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
        p1_1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
        p1_1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        p1_1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
        p1_1_f: "編製統計資料、研究及政府刊物；以及",
        p1_1_g: "執行規則及規例[包括《教育條例》（香港法例第279章）及其附屬法例（例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》）和《資助則例》）]。",
        p1_2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。",

        h2: "可獲轉移資料者",
        p2_3: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        p2_3_a: "政府其他政策局及部門，包括教育局，以用於上文第1段所述的用途；",
        p2_3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
        p2_3_c: "你曾就披露個人資料給予訂明同意；以及",
        p2_3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

        h3: "查閱個人資料",
        p3_4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向行政主任（資優教育）提出（地址：九龍九龍塘沙福道19號教育局九龍塘教育服務中心東座3樓E328室或電郵：exoge@edb.gov.hk）。",
    },
    dialog: {
        title: "*** 申請程序尚未完成 ***",
        content: `申請程序尚未完成，請繼續以下程序：<br />
        <br />
        1. 下載你已提交的申請表並列印；<br />
        2. 請機構負責人在申請表上簽名及蓋章；以及<br />
        3. 掃描已簽名及蓋章的申請表，並上載至系統<br />
        <br />
        請注意，我們已向你註冊的電子郵件地址發送一封電子郵件，提醒你有關申請程序尚未完成。<br />
        <br />
        當你完成所有申請程序，並當教育局收到你的申請後，你將收到一封確認電子郵件。`,
    },
};

export default Form091TC;
